import styled from 'styled-components';

/** Icon size for copy / layer / delete floating bar (keep in sync). */
export const FLOATING_TOOLBAR_ICON_SIZE = 22;

export const StyledFloatingToolbarBar = styled.div.attrs({
  className: 'respark_floating-toolbar-bar',
})`
  position: absolute;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 4px;
  min-height: 40px;
  box-sizing: border-box;
  background: var(--theme-overlay-bg, #fff);
  border: 1px solid var(--theme-overlay-border, #dee1ec);
  border-radius: 8px;
  box-shadow: 0 8px 24px var(--theme-overlay-shadow, rgba(15, 23, 42, 0.12));
  transform: translateX(-50%);

  * {
    font-family: Poppins, system-ui, sans-serif;
  }
`;

export const StyledFloatingToolbarButton = styled.button`
  appearance: none;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: var(--theme-overlay-text, #1f2a44);
  cursor: pointer;
  margin: 0;
  padding: 6px;
  min-width: 32px;
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  flex-shrink: 0;
  transition: background 0.15s ease;

  svg {
    display: block;
    width: ${FLOATING_TOOLBAR_ICON_SIZE}px;
    height: ${FLOATING_TOOLBAR_ICON_SIZE}px;
    flex-shrink: 0;
  }

  &:hover {
    background: var(--theme-overlay-hover, #ecf3ff);
  }

  &:active {
    background: var(--theme-overlay-subtle, #dce8fc);
  }

  &:focus-visible {
    outline: 2px solid #7c9cff;
    outline-offset: 1px;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
  }
`;

export const StyledFloatingToolbarButtonGroup = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 2px;
`;
